import React, { Component } from 'react';
import { Field } from 'redux-form';

import {renderErrorAlert, renderField} from "../Common/RenderFieldTypes";

import "./TeamEdit.css";

class TeamEdit extends Component {
    
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (this.props.match && this.props.match.params && this.props.match.params.id) {
            this.props.fetchTeam(this.props.match.params.id)
        }
    }

    onSubmit(val) {
        this.setState({submitError: ''});
        return this.props.createTeam(val).then((response) => {
            if (response.payload) {
                if (response.payload.name === 'ValidationError') {
                    this.setState({
                        submitError: 'There was an error submitting. Please try again.'
                    });
                } else {
                    this.props.history.push(`/teams`);
                }
            } else {
                this.setState({
                    submitError: 'There was an error submitting. Please try again.'
                });
            }
        });
    }

    render() {
        const { handleSubmit, pristine, submitting, submitFailed, error  } = this.props;
        return (
            <div>
                <h1>Team Creation</h1>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <Field name="teamName" className="form-control" component={renderField} type={"text"} label="Team Name" />
                    <Field name="description" className="form-control" component={renderField} type={"text"} label="Description" />
                    <Field name="imageURL" className="form-control" component={renderField} type={"text"} label="Image URL" />
                    <Field name="owner" className="form-control" component={renderField} type={"text"} label="Owner" disabled={!!this.props.id} />
                    <div id="submitArea">
                        <button type="submit" className="btn btn-success float-left" disabled={pristine || submitting}>
                            {submitting ? 'Saving...' : 'Save'}
                        </button>
                        {renderErrorAlert(submitFailed, error, this.state.submitError)}
                    </div>
                </form>
            </div>
        );
    }
}
export default TeamEdit;



// WEBPACK FOOTER //
// ./src/components/Team/TeamEdit.js